import { FC, HTMLAttributes, ReactNode } from 'react';

import { Flex, Typography } from 'antd';
import cn from 'classnames';

import styles from './OnboardingText.module.scss';

interface IOnboardingTextProps extends HTMLAttributes<HTMLDivElement> {
	header: ReactNode;
	text: ReactNode;
	isSteps?: boolean;
}

export const OnboardingText: FC<IOnboardingTextProps> = ({ className, header, text, isSteps, ...props }) => {
	return (
		<Flex
			{...props}
			vertical
			align={isSteps ? 'start' : 'center'}
			gap={isSteps ? 16 : 24}
			className={cn(className, styles.text, { [styles.steps]: isSteps })}>
			<Typography.Title level={isSteps ? 4 : 3} style={{ margin: 0 }}>
				{header}
			</Typography.Title>
			<Typography.Text type="secondary" style={{ margin: 0, fontSize: 16 }}>
				{text}
			</Typography.Text>
		</Flex>
	);
};
